/**Import react section */
import React, { useState } from 'react'
/**Import common components */
import TextBox from './../../../common/TextBox'
import ButtonConfirm from './../../../common/Buttons/ButtonConfirm'
/**Import MaterialUi section */
import { Grid } from '@material-ui/core'
import { createServicesStyle } from '../../../../resources/styles/CreateServiceStyles'

const WaitingService = (props) => {
	const { onSetPasswordDialogConfiguration, IsClosed } = props
	const classes = createServicesStyle()

	const [waitingModel, setWaitingModel] = useState({
		comments: '',
		status: props.status
	})

	const openModalForWaitingService = () => {
		if (onSetPasswordDialogConfiguration) onSetPasswordDialogConfiguration(waitingModel)
	}

	/**On change properties */
	const onPropertyChange = (event) => {
		let { name, value } = event.target
		setWaitingModel({
			...waitingModel,
			[name]: value
		})
	}

	/**Verify if can be saved */
	const canBeSaved = () => {
		if (waitingModel ? waitingModel.comments.length <= 0 : true) return false
		return true
	}

	return (
		<div>
			<Grid item xs={12}>
				<TextBox
					active={true}
					fullWidth
					autoFocus
					disabled={IsClosed}
					name='comments'
					variant='outlined'
					margin='dense'
					label='REASON FOR WAITING'
					multiline
					rows={4}
					onChange={onPropertyChange}
					value={waitingModel ? waitingModel.comments : ''}
				/>
			</Grid>
			{!IsClosed && (
				<Grid item xs={12} className={classes.updateButton}>
					<ButtonConfirm title='CONFIRM' isSaving={!canBeSaved()} onSavedClick={openModalForWaitingService} />
				</Grid>
			)}
		</div>
	)
}
export default WaitingService
